import gql from 'graphql-tag';

export const getTargets = gql`
{
  targets (first: 500) {
    edges {
      node {
        id
        name
        logo
        enabled
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/queries/Target.js